import React, { MouseEvent as Event, FC, useState } from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../constants/aampeTheme';
// icons
import ICONS from '../../constants/icons';

//hooks
import useAnalytics from '../../hooks/helper/useAnalytics';

// models
import { LearnTypeDataModel } from '../../models/learn.model';

// components
import YoutubeEmbed from '../display/video/YoutubeEmbed';
import LearnModal from '../modals/learnModal';
import AampeTooltip from '../shared/AampeTooltip/AampeTooltip';
import LearnVideoPreviewPopup from './LearnVideoPreviewPopup';

interface LearnVideoSectionProps {
    learnData: LearnTypeDataModel;
}

const LearnVideoSection: FC<React.PropsWithChildren<LearnVideoSectionProps>> =
    ({ learnData }) => {
        const [videoPreviewAnchorEl, setVideoPreviewAnchorEl] =
            useState<Element | null>(null);
        const [isVideoOpen, setIsVideoOpen] = useState<boolean>(false);

        const { track } = useAnalytics();

        const handlePopupOpen = (event: Event<Element, MouseEvent>) => {
            setVideoPreviewAnchorEl(event.target as Element);
            track('learn_icon_clicked', {
                page: learnData.title,
            });
        };

        return (
            <>
                <AampeTooltip
                    arrow
                    title="Click here for a short video tutorial on how to use this page"
                >
                    <VideoHelpIcon onClick={handlePopupOpen}>
                        <ICONS.learnVideo color={aampeTheme.colors.white} />
                    </VideoHelpIcon>
                </AampeTooltip>

                <LearnVideoPreviewPopup
                    anchorEl={videoPreviewAnchorEl}
                    handleClose={() => setVideoPreviewAnchorEl(null)}
                    learnData={learnData}
                    setVideoIsOpen={setIsVideoOpen}
                />
                {isVideoOpen && (
                    <LearnModal
                        handleClose={() => setIsVideoOpen(false)}
                        title={learnData.title}
                    >
                        <YoutubeEmbed embedId={learnData.embedId} />
                    </LearnModal>
                )}
            </>
        );
    };

const VideoHelpIcon = styled.div({
    boxShadow:
        '0px 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)',
    borderRadius: '50%',
    padding: aampeTheme.spacing(2),
    width: '56px',
    height: '56px',
    marginLeft: 'auto',
    backgroundColor: aampeTheme.colors.solidA01,
    cursor: 'pointer',
    marginTop: aampeTheme.spacing(2),
    position: 'fixed',
    bottom: 20,
    right: 20,
    zIndex: 10,
});

export default LearnVideoSection;
